export default __webpack_public_path__ + "static/media/hub.0556ddb3.png";